import React,{useEffect} from "react";
import Aux from "../../HOC/Aux";
import {FaUser} from "react-icons/fa";
const SignIn = ()=>{
    useEffect(()=>{
        document.title = "Beach resort | Sign In"
        window.scrollTo(0,0);
    },[]);

    return(
        <Aux>
            <section className="signIn-bcg">
                    <div className="signIn-layout"></div>
                <form className="signIn-box container ">
                    
                    <div className="signIn-upper-icon"><FaUser/></div>
                    <h3 className="signIn-title">Login Here</h3>
                    <label htmlFor="username">Username</label>
                    <input autoFocus id="username" type="text" placeholder="Enter Username" />
                    <label htmlFor="password">Password</label>
                    <input id="password" type="password" placeholder="Enter password" />
                    <input className="signIn-btn" type="submit" value="Login"/>
                    <p className="signIn-fake-link">Lost your password?</p>
                    <p className="signIn-fake-link">Don't have an account?</p>
                </form>

            </section>
        </Aux>
    )
}

export default SignIn;